import { useState } from "react";
import { Box, Grid } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import IntelligenceTimeFilter from "../../../../components/IntelligenceTimeFilter";
import MainFG from "./forceGraph";
import IpTable from "./table";
import ProtocolsCard from "./ProtocolsCard";

dayjs.extend(utc);
dayjs.extend(timezone);

// "Connections" tab — everything about this asset's internal conduits in one
// view: the connections graph (top-left, bigger), the protocols card
// (top-right), and the connections table (below). One shared time filter
// drives all three, styled like the one used on the security grids
// (IntelligenceTimeFilter). Purely a data view — no security-log drill-down,
// each row/edge is already the full conduit record.
const TrafficConnectionsPanel = ({ ip }) => {
  const tz = sessionStorage.getItem("timezone") || "Etc/GMT";
  const [dateFilter, setDateFilter] = useState({
    dateFrom: dayjs().tz(tz).subtract(1, "day"),
    dateTo: dayjs().tz(tz),
  });
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleChangeDate = (newDateFilter) => {
    setDateFilter({
      dateFrom: dayjs(newDateFilter.dateFrom).tz(tz),
      dateTo: dayjs(newDateFilter.dateTo).tz(tz),
    });
  };

  return (
    <Box sx={{ p: "1rem" }}>
      <IntelligenceTimeFilter
        onDateChange={handleChangeDate}
        initialDateFrom={dateFilter.dateFrom}
        initialDateTo={dateFilter.dateTo}
      />

      {/* Graph and protocol summary share one data source (graphData, populated
          by the table below) — while loading they still show their own
          spinner/skeleton, but once loaded with nothing to show, the whole row
          disappears rather than leaving two empty-looking boxes above the table. */}
      {(loading || graphData.length > 0) && (
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid size={7} sx={{ height: 440 }}>
            <MainFG
              ipAddress={ip}
              graphData={graphData}
              charged={!loading}
            />
          </Grid>
          <Grid size={5} sx={{ height: 440 }}>
            <ProtocolsCard conduits={graphData} />
          </Grid>
        </Grid>
      )}

      <Box sx={{ mt: 2, height: "55vh" }}>
        <IpTable
          ipAddress={ip}
          loading={loading}
          setLoading={setLoading}
          setGraphData={setGraphData}
          dateFilter={dateFilter}
        />
      </Box>
    </Box>
  );
};

export default TrafficConnectionsPanel;
